import axios from 'axios';
import utils from './functions-base/utils';

declare let core_object: any;
declare let auth_object: any;

// Utils
const modUtils = new utils();

export default class authLogout{

    protected elBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_logout: string;

    /**
     * Constructor
     * @param elBtn
     */
    constructor(
        elBtn: string,
    ){
        
        this.elBtn = elBtn;
        this.url_api_logout = auth_object.rest_urls.auth_logout;

    }

    // Logout
    logout(){
        
        const _that = this;

        const el = document.querySelector(this.elBtn) as HTMLButtonElement;

        el?.addEventListener("click", function(e){
            e.preventDefault();

            // Init spin
        const spin = modUtils.btnSpin(_that.elFormSpin);

            // Append spin to button
            el?.append(spin);

            // Call ajax
            axios.post(_that.url_api_logout)
                .then(function (response: any) {

                const responseStatus: boolean = response.data.status;

                if(responseStatus == true){
                    
                    // Refresh the page
                    location.reload();
                    
                }
                    
                if(responseStatus == false){
                
                    
                
                }

            })
            .catch(function (error:any){

                const message = auth_object.error_messages.general;
                

            });

        });
    
    }

}